"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBaseEventPayload = exports.getHasDisableMargin = exports.getCanViewGiftingOnTheFly = exports.getCanViewDepositLedger = exports.getCanViewBillingInsights = exports.getCanUseGiftCreateFlow = exports.getOrgCanUseChromeExtension = exports.getIsUsingDKIM = exports.getOrganizationPrefix = exports.getIsTeamManageable = exports.getUserTimezone = exports.getUserCanManageTeams = exports.getIsUserLoading = exports.getUserDefaultTeam = exports.getUserImage = exports.getOrgName = exports.getOrgId = exports.getUserEmail = exports.getUserFullName = exports.getUserName = exports.getUserId = exports.getUserError = exports.getUser = void 0;

var _ramda = require("ramda");

var _reselect = require("reselect");

var _features = require("../features");

var _store = require("../../../Auth/store");

var getUser = function getUser(state) {
  return state.modules.user;
};

exports.getUser = getUser;
var getUserError = (0, _ramda.pipe)(getUser, function (user) {
  return user.error;
});
exports.getUserError = getUserError;
var getUserId = (0, _ramda.pipe)(getUser, function (user) {
  return user.id;
});
exports.getUserId = getUserId;
var getUserName = (0, _reselect.createSelector)(getUser, function (_ref) {
  var firstName = _ref.firstName,
      lastName = _ref.lastName;
  return "".concat(firstName, " ").concat(lastName ? "".concat(lastName[0], ".") : '');
});
exports.getUserName = getUserName;
var getUserFullName = (0, _reselect.createSelector)(getUser, function (_ref2) {
  var firstName = _ref2.firstName,
      lastName = _ref2.lastName;
  return "".concat(firstName, " ").concat(lastName);
});
exports.getUserFullName = getUserFullName;
var getUserEmail = (0, _ramda.pipe)(getUser, function (user) {
  return user.email;
});
exports.getUserEmail = getUserEmail;
var getOrgId = (0, _ramda.pipe)(getUser, function (user) {
  return user.organisation.id;
});
exports.getOrgId = getOrgId;
var getOrgName = (0, _ramda.pipe)(getUser, function (user) {
  return user.organisation.name;
});
exports.getOrgName = getOrgName;
var getUserImage = (0, _ramda.pipe)(getUser, function (user) {
  return user.avatar;
});
exports.getUserImage = getUserImage;
var getUserDefaultTeam = (0, _ramda.pipe)(getUser, function (user) {
  return user.defaultTeam;
});
exports.getUserDefaultTeam = getUserDefaultTeam;
var getIsUserLoading = (0, _ramda.pipe)(getUser, function (user) {
  return user.isLoading;
});
exports.getIsUserLoading = getIsUserLoading;
var getUserCanManageTeams = (0, _ramda.pipe)(getUser, function (user) {
  return user.canManageTeams;
});
exports.getUserCanManageTeams = getUserCanManageTeams;
var getUserTimezone = (0, _ramda.pipe)(getUser, function (user) {
  return user.timezone;
});
exports.getUserTimezone = getUserTimezone;

var getIsTeamManageable = function getIsTeamManageable(teamId) {
  return (0, _reselect.createSelector)(getUserCanManageTeams, function (manageableTeams) {
    return manageableTeams.includes(teamId);
  });
};

exports.getIsTeamManageable = getIsTeamManageable;
var getOrganizationPrefix = (0, _ramda.pipe)(getUser, function (user) {
  return user.organisationUrlPrefix;
});
exports.getOrganizationPrefix = getOrganizationPrefix;
var getIsUsingDKIM = (0, _ramda.pipe)(getUser, function (user) {
  return user.organisation.usingDKIM;
});
exports.getIsUsingDKIM = getIsUsingDKIM;
var getOrgCanUseChromeExtension = (0, _ramda.pipe)(getUser, function (user) {
  return user.organisation.canUseChromeExtension;
}); // @todo: Temporary fix. Need to look through code and remove getCanUseGiftCreateFlow.

exports.getOrgCanUseChromeExtension = getOrgCanUseChromeExtension;

var getCanUseGiftCreateFlow = function getCanUseGiftCreateFlow() {
  return true;
};

exports.getCanUseGiftCreateFlow = getCanUseGiftCreateFlow;
var getCanViewBillingInsights = (0, _reselect.createSelector)(_features.Features.selectors.getFeaturesIsLoading, _features.Features.selectors.hasFeatureFlag(_features.Features.FLAGS.BILLING_INSIGHTS), getIsUserLoading, getUserCanManageTeams, function (featuresIsLoading, billingInsightsEnabled, userIsLoading, managedTeams) {
  if (!featuresIsLoading && !userIsLoading && Array.isArray(managedTeams)) {
    return billingInsightsEnabled && managedTeams.length > 0;
  }

  return undefined;
});
exports.getCanViewBillingInsights = getCanViewBillingInsights;
var getCanViewDepositLedger = (0, _reselect.createSelector)(_features.Features.selectors.getFeaturesIsLoading, _features.Features.selectors.hasFeatureFlag(_features.Features.FLAGS.SHOW_DEPOSIT_LEDGER), function (isLoading, depositLedgerEnabled) {
  return !isLoading ? depositLedgerEnabled : undefined;
});
exports.getCanViewDepositLedger = getCanViewDepositLedger;
var getCanViewGiftingOnTheFly = (0, _reselect.createSelector)(_features.Features.selectors.getFeaturesIsLoading, _features.Features.selectors.hasFeatureFlag(_features.Features.FLAGS.GIFTING_ON_THE_FLY), function (isLoading, giftingOnTheFlyEnabled) {
  return !isLoading ? giftingOnTheFlyEnabled : undefined;
});
exports.getCanViewGiftingOnTheFly = getCanViewGiftingOnTheFly;
var getHasDisableMargin = (0, _reselect.createSelector)(_features.Features.selectors.getFeaturesIsLoading, _features.Features.selectors.hasFeatureFlag(_features.Features.FLAGS.DISABLE_MARGIN), function (isLoading, disableMarginEnabled) {
  return !isLoading ? disableMarginEnabled : undefined;
});
exports.getHasDisableMargin = getHasDisableMargin;
var getBaseEventPayload = (0, _reselect.createSelector)(_store.getLoginAsAdminId, getOrgId, getOrgName, function () {
  var adminId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var orgId = arguments.length > 1 ? arguments[1] : undefined;
  var orgName = arguments.length > 2 ? arguments[2] : undefined;
  return [{
    impersonateId: adminId
  }, {
    groupId: orgId,
    traits: {
      adminId,
      orgName,
      orgId
    }
  }];
});
exports.getBaseEventPayload = getBaseEventPayload;